import { render, staticRenderFns } from "./PostFilters.vue?vue&type=template&id=7f3925be&scoped=true&"
import script from "./PostFilters.vue?vue&type=script&lang=js&"
export * from "./PostFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3925be",
  null
  
)

export default component.exports